import React from 'react';
import { Headphones, ShieldCheck, FileCheck } from 'lucide-react';
import { whyUsFeatures as features } from '../data/mock';

const iconMap = {
  HeadphonesIcon: Headphones,
  ShieldCheckIcon: ShieldCheck,
  FileCheckIcon: FileCheck
};

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-black relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-1/2 left-0 w-96 h-96 bg-amber-500/5 rounded-full blur-[120px] -translate-y-1/2 animate-float" />
      <div className="absolute top-1/2 right-0 w-80 h-80 bg-amber-600/5 rounded-full blur-[100px] -translate-y-1/2 animate-float animation-delay-500" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 animate-fadeInUp">
            About
            <span className="text-gold-gradient"> Grand Line Rentals</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto animate-fadeInUp animation-delay-100">
            Your trusted partner for luxury car rentals in the Greater Toronto Area
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group relative card-gold rounded-2xl p-8 animate-fadeInUp hover-lift"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-gradient-to-br from-amber-500/20 to-amber-600/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:shadow-[0_0_30px_rgba(212,160,23,0.3)] transition-all duration-500">
                  {IconComponent && (
                    <IconComponent className="w-8 h-8 text-amber-400 group-hover:animate-pulse" />
                  )}
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-amber-400 transition-colors duration-300">
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {feature.description}
                </p>

                {/* Hover glow effect */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-amber-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
